import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HolderLicences from '../../components/licences/HolderLicences';
import { licencesApi, errorOf } from '../../lib/licences';
import '../../components/Assets.css';
import '../../components/licences/Licences.css';

/**
 * A PERSON'S LICENCES (119): every seat they hold, with Free, a seat of
 * another licence given from here, and what they held before. Reached from
 * a licence's seat list, a licence's owner, Settings -> Users and the joiner
 * and leaver checklists. Administrators only.
 */
export default function LicencePerson() {
  const { userId } = useParams();
  const [person, setPerson] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    licencesApi.person(userId)
      .then((d) => { if (live) setPerson(d.person); })
      .catch((e) => { if (live) setError(e?.response?.status === 404 ? 'That person is not in Jarvis.' : errorOf(e, 'Could not load their licences.')); });
    return () => { live = false; };
  }, [userId]);

  return (
    <div className="container" data-testid="licence-person">
      <p className="lic-back"><Link to="/assets/licences">← Licences</Link></p>
      {error ? <div className="empty-state"><p>{error}</p></div> : (
        <>
          <div className="page-header">
            <h1 className="page-title">{person ? `${person.name}’s licences` : 'Licences'}</h1>
            {person && (
              <p className="page-description">
                {[person.email, person.department, person.active ? null : 'Deactivated'].filter(Boolean).join(' · ')}
              </p>
            )}
          </div>
          {person && !person.active && (
            <p className="as-note" data-tone="warning">They are deactivated. Free their seats so somebody else can have them.</p>
          )}
          <section className="as-panel lic-wide" aria-label="Their licences">
            <h2>Licence seats</h2>
            <HolderLicences kind="user" id={userId} />
          </section>
        </>
      )}
    </div>
  );
}
